import getAccountDetails from "../../../../react/core/services/accountDetailsService";
import { getActivity } from "../../../../react/core/services/keepAliveService";
import retrieveContactDetails from "../../../../react/core/services/retrieveContactDetailsService";

const DynamicElectionRoutingService = function () {
    const service = this;

    const success = function (data, parse = false) {
        if (parse) {
            return JSON.parse(data.data);
        }
        return data;
    };

    const fault = function (err) {
        console.error("Error in DynamicElectionRoutingService", err);
        throw new Error(err);
    };

    service.getTime = function () {
        return getActivity().then((data) => success(data, true), fault);
    };

    service.getDetails = (params) => {
        return getAccountDetails(params).then(success, fault);
    };

    service.getContactDetails = function () {
        return retrieveContactDetails().then(success, fault);
    };
};

export default DynamicElectionRoutingService;
